import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateSearchComponent } from "../../templates/template-search/template-search.component";
import { SelectOption } from "../../templates/template-select/template-select.component";

@Component({
  selector: "app-prefix-idf[options]",
  imports: [TemplateSearchComponent],
  templateUrl: "./prefix-idf.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-idf.component.less",
})
export class PrefixIdfComponent extends PrefixComponent<string> {
  @Input()
  public options: SelectOption[];

  public multiple: boolean;

  public constructor() {
    super();
    this.options = [];
    this.multiple = false;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["idf"];
  }
}
